import { z } from 'zod';
import { OrderModifierSchema } from './OrderModifier';

export const OrderModifierGroupSchema = z.object({
    modifierGroupId: z.number().int().positive(),
    name: z.string().min(1),
    modifiers: z.array(OrderModifierSchema).default([]),
});

export const OrderModifierGroupDataSchema = z.object({
    modifierGroupId: z.number().int().positive(),
    name: z.string().min(1),
    modifiers: z.array(OrderModifierSchema).optional().default([]),
});

export type OrderModifierGroupSchemaType = z.infer<typeof OrderModifierGroupSchema>;
export type OrderModifierGroupDataSchemaType = z.infer<typeof OrderModifierGroupDataSchema>;
